import { useState } from 'react';
import { Autocomplete, Chip, TextField } from '@mui/material';

import { MultiSelectAutocompleteProps } from '../../../models/ui';

const RATP_BLUE = '#0a0082';

/**
 * Composant générique remplaçant react-dropdown-select par MUI Autocomplete.
 *
 * - Gère l'état local des valeurs sélectionnées
 * - Bordure du champ en bleu RATP
 * - Chips des valeurs sélectionnées encadrées en bleu RATP
 */
const MultiSelectAutocomplete = <T,>({
	disabled = false,
	getOptionLabel,
	isOptionEqualToValue,
	onChange,
	options,
	placeholder,
}: MultiSelectAutocompleteProps<T>) => {
	const [selected, setSelected] = useState<T[]>([]);

	const handleChange = (_: React.SyntheticEvent, values: T[]) => {
		setSelected(values);
		onChange(values);
	};

	return (
		<Autocomplete
			disabled={disabled}
			getOptionLabel={getOptionLabel}
			isOptionEqualToValue={isOptionEqualToValue}
			multiple
			onChange={handleChange}
			options={options}
			renderInput={(params) => (
				<TextField
					{...params}
					placeholder={selected.length === 0 ? placeholder : undefined}
					size="small"
					sx={{
						'& .MuiOutlinedInput-root fieldset': {
							borderColor: RATP_BLUE,
						},
						'& .MuiOutlinedInput-root.Mui-focused fieldset': {
							borderColor: RATP_BLUE,
						},
						'& .MuiOutlinedInput-root:hover fieldset': {
							borderColor: RATP_BLUE,
						},
					}}
				/>
			)}
			renderTags={(values, getTagProps) =>
				values.map((option, index) => (
					<Chip
						{...getTagProps({ index })}
						key={getOptionLabel(option)}
						label={getOptionLabel(option)}
						size="small"
						sx={{
							'& .MuiChip-deleteIcon': {
								'&:hover': { color: '#06004f' },
								color: RATP_BLUE,
							},
							backgroundColor: '#fff',
							border: `1px solid ${RATP_BLUE}`,
							borderRadius: '4px',
							color: RATP_BLUE,
							fontWeight: 600,
						}}
					/>
				))
			}
			value={selected}
		/>
	);
};

export default MultiSelectAutocomplete;
